import React from 'react';
import './AcademicYear.css';

const AcademicYear = () => {
  return (
    <div className="academic-year-card">
      <div className="card-header">
      
      </div>
      <div className="card-content">
        {/* Placeholder for academic year details */}
      </div>
    </div>
  );
};

export default AcademicYear;
